import { useEffect } from "react";
import { useSelector } from "react-redux";

import { useDialogs } from "@src/hooks/dialog";
import { useDiscountSyncErrorToast } from "@src/hooks/toast";
import { useDispatch } from "@src/store";
import { useQueryClient } from "@tanstack/react-query";

import { useGetOrg } from "../api/organizations/get-organization";
import { useWebsocket } from "../hooks/websocket";
import { getIgnoreUpdateDetected } from "../store/slices/global";
import { selectedExperience } from "../store/slices/experiences";
import { useEditPageExperienceId, useIsEditPage } from "../utils/constants";
import { handleWebsocketMessage } from "./websocketMessageHandler";

export const WebsocketProvider = () => {
  const organization = useGetOrg();
  const websocket = useWebsocket();
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const isEditPage = useIsEditPage();
  const editPageExperienceId = useEditPageExperienceId();
  const discountSyncErrorToast = useDiscountSyncErrorToast();

  const ignoreUpdateDetected = useSelector(getIgnoreUpdateDetected);
  const currentExperience = useSelector(selectedExperience);
  const { openDialog, closeDialog, isDialogOpen } = useDialogs();

  const isUpdateDetectedDialogOpen = isDialogOpen("updatedDetected");
  const isRedirectToPluginDialogOpen = isDialogOpen("redirectToPlugin");

  useEffect(() => {
    if (
      !isEditPage &&
      isUpdateDetectedDialogOpen &&
      !isRedirectToPluginDialogOpen
    ) {
      closeDialog("updatedDetected");
    }
  }, [
    isEditPage,
    isUpdateDetectedDialogOpen,
    isRedirectToPluginDialogOpen,
    closeDialog,
  ]);

  const message = websocket.lastJsonMessage;
  const orgId = organization.data.org.id;

  useEffect(() => {
    if (message) {
      handleWebsocketMessage(message, {
        currentExperience,
        dispatch,
        editPageExperienceId,
        discountSyncErrorToast,
        ignoreUpdateDetected,
        isDialogOpen,
        isEditPage,
        openDialog,
        orgId,
        queryClient,
      });
    }
  }, [message, orgId]);

  return null;
};
